module.exports = "<div ng-repeat=\"listing in $ctrl.data | orderBy: 'meta.creationDate':true\">\n    <div ng-show=\"$index > 0\" style=\"width:100%; text-align:center\">\n        <img src=\"./assets/images/line-divider.png\" />\n    </div>\n    <bulletin-post data=\"listing\" preview=\"true\" property=\"true\" url=\"$ctrl.url\"></bulletin-post>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/bulletin/property-list/bulletin-property-list.html
// module id = 111
// module chunks = 0